import Vue from 'vue'
import Agenda from '../vue/Agenda.vue'

export default {
  init() {
    new Vue({
      el: '#app',
      components: {
        Agenda,
      },
    })
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/agenda.js